<div class="w-100 float-left">
    <div class="w-100 float-left v-align relative" (click)="clicked();closeEmployeeFilter()">
        <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
            <h5 class="medium m-0">{{'empAdvSearch' | translate}}</h5>
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-secondary" (click)="goToValBackPage()">
                <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
            </button>
        </div>
    </div>
    <div (click)="clicked()">
        <employeeFilter [displayTab]="'startProgram'" (searchEmp)="showSearchFilter($event)"></employeeFilter>
    </div>
    <!-- EMPLOYEE DETAILS GRID -->
    <div class="w-100 float-left mt-3" (click)="closeEmployeeFilter()">
        <div class="light-bg w-100 float-left p-2 grid-details">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'employeeId' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-lg-0 medium"> {{'name' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'orgUit' | translate}}</h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'selectGrade' | translate}} </h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                <h6 class="mb-lg-0 medium"> {{'designation' | translate}} </h6>
            </div>

        </div>
        <ng-container *ngIf="employeeData.length > 0">
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let employee of employeeData; let i=index">
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                    <h6 class="mb-lg-0 text-truncate"> {{employee.empCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-lg-0 text-truncate"> {{employee.displayName}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.orgId != null"> {{employee.orgName}}
                        ({{employee.orgCode}}) </h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.orgId == null"> {{'notAvailable' | translate}}
                    </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.gradeName != null"> {{employee.gradeName}} </h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.gradeName == null"> {{'notAvailable' |
                        translate}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.designationName != null">
                        {{employee.designationName}} </h6>
                    <h6 class="mb-lg-0 text-truncate" *ngIf="employee.designationName == null"> {{'notAvailable' |
                        translate}} </h6>
                </div>


            </div>
        </ng-container>
        <ng-container *ngIf="employeeData.length == 0">
            <div class="w-100 float-left min-h2 relative" *ngIf="showLoading">
                <div class="loader-div">
                    <div class="loader-gif"></div>
                </div>
            </div>
            <div class="w-100 float-left p-4 grid-details" *ngIf="!showLoading">
                <p class="text-center m-0 w-100 medium">{{'noResultFound' | translate}}</p>
            </div>
        </ng-container>
    </div>

    <!-- PAGINATION -->
    <div class="w-100 float-left my-4 light-bg p-3 align-v-center" (click)="clicked();closeEmployeeFilter()">
        <h6 class="float-left mb-0 mr-4"> {{((searchData.page-1)*searchData.pageSize)+1}} -
            {{searchData.pageSize*(searchData.page-1)+employeePageData.numberOfElements}}
            {{'itemsOf' | translate}} {{employeePageData.totalElements}} </h6>
        <div class="float-left ml-2 align-v-center">
            <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
            <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="searchData.pageSize"
                    (change)="onPageSizeChange()">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div style="flex-grow: 1;"></div>
        <ngb-pagination [collectionSize]="employeePageData.totalElements" [rotate]="true"
                        [pageSize]="searchData.pageSize"
                        [(page)]="searchData.page" [boundaryLinks]="true" [maxSize]="5" [ellipses]="false"
                        (pageChange)="getEmployee()"
                        [maxSize]="5" class="float-right"></ngb-pagination>
    </div>
    <div class="w-100 float-left" (click)="closeEmployeeFilter()">
        <button class="btn btn-primary float-right mb-4" (click)="startProgram()" [disabled]="showButtonLoading"
                *ngIf="employeeData.length>0 && displayType=='Start'">
            <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i> {{'startProg' |
            translate}}
        </button>
        <button class="btn btn-primary float-right mb-4" (click)="assignSwitchUserPermission()"
                [disabled]="showButtonLoading" *ngIf="employeeData.length>0 && displayType=='SWITCH'">
            <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i> {{'addEmployee' |
            translate}}
        </button>
        <button class="btn btn-primary float-right mb-4" (click)="validateAndTrigger()" [disabled]="showButtonLoading"
                *ngIf="employeeData.length>0  && displayType=='Trigger'">
            <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i> {{'triggerReview' |
            translate}}
        </button>
        <button class="btn btn-primary float-right mb-4" (click)="enrollEmployeesConfirm()"
                [disabled]="showButtonLoading"
                *ngIf="employeeData.length>0  && (displayType=='EnrollPerformance' || displayType=='EnrollCompetency' || displayType=='EnrollCheckin') ">
            <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i> {{'enrollEmployees' |
            translate}}
        </button>
        <button class="btn btn-primary float-right mb-4" (click)="announcementEmployeeConfirm()"
                [disabled]="showButtonLoading"
                *ngIf="employeeData.length>0  && displayType=='Announcement'">
            <i *ngIf="showButtonLoading" class="fa fa-spinner fa-spin text-white m-l-smd"></i> {{'makeAnnouncementNow' |
            translate}}
        </button>
        <button class="btn btn-primary float-right" (click)="finalAddRole()"
                *ngIf="employeeData.length>0 && displayType=='Role'"
                [disabled]="disableButton">{{'add' | translate}}
        </button>

        <button class="btn btn-primary float-right" (click)="finalAddUsers()"
                *ngIf="employeeData.length>0 && displayType=='UserGroup'"
                [disabled]="disableButton">{{'add' | translate}}
        </button>
    </div>


// WEBPACK FOOTER //
// ./src/app/employee/employeeSearch.html